import "esbuild-css-modules-plugin-ns-css:src/js/pages/resultsStep/resultsStep.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/pages/resultsStep/resultsStep.module.css:injector.js";
export default new Proxy({
  "accordionBodyWrapper": "resultsStep-module__accordionBodyWrapper_dsellG__1100",
  "accordionBodyWrapperOverride": "resultsStep-module__accordionBodyWrapperOverride_dsellG__1100",
  "accordionButton": "resultsStep-module__accordionButton_dsellG__1100",
  "accordionButtonCustom": "resultsStep-module__accordionButtonCustom_dsellG__1100",
  "accordionController": "resultsStep-module__accordionController_dsellG__1100",
  "accordionExpandableContainer": "resultsStep-module__accordionExpandableContainer_dsellG__1100",
  "accordionIcon": "resultsStep-module__accordionIcon_dsellG__1100",
  "accordionOpenOverride": "resultsStep-module__accordionOpenOverride_dsellG__1100",
  "arrowIcon": "resultsStep-module__arrowIcon_dsellG__1100",
  "auAccordionOverride": "resultsStep-module__auAccordionOverride_dsellG__1100",
  "bodyContainer": "resultsStep-module__bodyContainer_dsellG__1100",
  "bodyWrapperCustom": "resultsStep-module__bodyWrapperCustom_dsellG__1100",
  "btnExpandSubdivision": "resultsStep-module__btnExpandSubdivision_dsellG__1100",
  "cardContainer": "resultsStep-module__cardContainer_dsellG__1100",
  "categoryBox": "resultsStep-module__categoryBox_dsellG__1100",
  "categoryList": "resultsStep-module__categoryList_dsellG__1100",
  "chevron": "resultsStep-module__chevron_dsellG__1100",
  "chevronExpanded": "resultsStep-module__chevronExpanded_dsellG__1100",
  "citationAndLinkContainer": "resultsStep-module__citationAndLinkContainer_dsellG__1100",
  "citationLink": "resultsStep-module__citationLink_dsellG__1100",
  "classNameBtn": "resultsStep-module__classNameBtn_dsellG__1100",
  "closeModalButton": "resultsStep-module__closeModalButton_dsellG__1100",
  "collapsibleSectionsListContainer": "resultsStep-module__collapsibleSectionsListContainer_dsellG__1100",
  "collapsibleSubdivision": "resultsStep-module__collapsibleSubdivision_dsellG__1100",
  "contentContainer": "resultsStep-module__contentContainer_dsellG__1100",
  "disclaimerModalBackground": "resultsStep-module__disclaimerModalBackground_dsellG__1100",
  "disclaimerModalButtonContainer": "resultsStep-module__disclaimerModalButtonContainer_dsellG__1100",
  "disclaimerModalContainer": "resultsStep-module__disclaimerModalContainer_dsellG__1100",
  "disclaimerModalText": "resultsStep-module__disclaimerModalText_dsellG__1100",
  "disclaimerModalTitle": "resultsStep-module__disclaimerModalTitle_dsellG__1100",
  "divider": "resultsStep-module__divider_dsellG__1100",
  "editDetailsButton": "resultsStep-module__editDetailsButton_dsellG__1100",
  "expandableLabel": "resultsStep-module__expandableLabel_dsellG__1100",
  "expendedListContainer": "resultsStep-module__expendedListContainer_dsellG__1100",
  "expendedListContainerHidden": "resultsStep-module__expendedListContainerHidden_dsellG__1100",
  "exportModalButtonContainer": "resultsStep-module__exportModalButtonContainer_dsellG__1100",
  "exportModalCloseButton": "resultsStep-module__exportModalCloseButton_dsellG__1100",
  "exportModalCloseIcon": "resultsStep-module__exportModalCloseIcon_dsellG__1100",
  "exportModalContainer": "resultsStep-module__exportModalContainer_dsellG__1100",
  "exportModalHeading": "resultsStep-module__exportModalHeading_dsellG__1100",
  "exportModalText": "resultsStep-module__exportModalText_dsellG__1100",
  "fieldset": "resultsStep-module__fieldset_dsellG__1100",
  "filterAndContentContainer": "resultsStep-module__filterAndContentContainer_dsellG__1100",
  "filterButtonMobile": "resultsStep-module__filterButtonMobile_dsellG__1100",
  "filterButtonMobileIcon": "resultsStep-module__filterButtonMobileIcon_dsellG__1100",
  "filterButtonMobileText": "resultsStep-module__filterButtonMobileText_dsellG__1100",
  "filterCheckbox": "resultsStep-module__filterCheckbox_dsellG__1100",
  "filterContainer": "resultsStep-module__filterContainer_dsellG__1100",
  "filterHeader": "resultsStep-module__filterHeader_dsellG__1100",
  "filterSubheader": "resultsStep-module__filterSubheader_dsellG__1100",
  "headerContainer": "resultsStep-module__headerContainer_dsellG__1100",
  "headerWrapper": "resultsStep-module__headerWrapper_dsellG__1100",
  "infoText": "resultsStep-module__infoText_dsellG__1100",
  "inverted": "resultsStep-module__inverted_dsellG__1100",
  "modalBackground": "resultsStep-module__modalBackground_dsellG__1100",
  "modalBtnClear": "resultsStep-module__modalBtnClear_dsellG__1100",
  "modalButtonContainer": "resultsStep-module__modalButtonContainer_dsellG__1100",
  "modalContainer": "resultsStep-module__modalContainer_dsellG__1100",
  "modalContent": "resultsStep-module__modalContent_dsellG__1100",
  "modalIcon": "resultsStep-module__modalIcon_dsellG__1100",
  "modalTitle": "resultsStep-module__modalTitle_dsellG__1100",
  "modalTitleBar": "resultsStep-module__modalTitleBar_dsellG__1100",
  "optionsContainer": "resultsStep-module__optionsContainer_dsellG__1100",
  "paddingWrapper": "resultsStep-module__paddingWrapper_dsellG__1100",
  "paginationButton": "resultsStep-module__paginationButton_dsellG__1100",
  "paginationButtonActive": "resultsStep-module__paginationButtonActive_dsellG__1100",
  "paginationButtonMobile": "resultsStep-module__paginationButtonMobile_dsellG__1100",
  "paginationButtonMobileActive": "resultsStep-module__paginationButtonMobileActive_dsellG__1100",
  "paginationContainer": "resultsStep-module__paginationContainer_dsellG__1100",
  "paginationDesktop": "resultsStep-module__paginationDesktop_dsellG__1100",
  "paginationEllipsis": "resultsStep-module__paginationEllipsis_dsellG__1100",
  "paginationMobile": "resultsStep-module__paginationMobile_dsellG__1100",
  "paginationPagesMobile": "resultsStep-module__paginationPagesMobile_dsellG__1100",
  "primaryContentWrapper": "resultsStep-module__primaryContentWrapper_dsellG__1100",
  "printButton": "resultsStep-module__printButton_dsellG__1100",
  "radioScopeOptions": "resultsStep-module__radioScopeOptions_dsellG__1100",
  "resetFilterButton": "resultsStep-module__resetFilterButton_dsellG__1100",
  "ruleContainer": "resultsStep-module__ruleContainer_dsellG__1100",
  "ruleContent": "resultsStep-module__ruleContent_dsellG__1100",
  "ruleMeta": "resultsStep-module__ruleMeta_dsellG__1100",
  "sectionContainer": "resultsStep-module__sectionContainer_dsellG__1100",
  "sectionLabel": "resultsStep-module__sectionLabel_dsellG__1100",
  "sectionName": "resultsStep-module__sectionName_dsellG__1100",
  "showMoreButton": "resultsStep-module__showMoreButton_dsellG__1100",
  "source": "resultsStep-module__source_dsellG__1100",
  "sourceCitationLink": "resultsStep-module__sourceCitationLink_dsellG__1100",
  "sourceSubHeader": "resultsStep-module__sourceSubHeader_dsellG__1100",
  "subDivisionAndSectionWrapper": "resultsStep-module__subDivisionAndSectionWrapper_dsellG__1100",
  "subdivisionContainer": "resultsStep-module__subdivisionContainer_dsellG__1100",
  "subdivisionLabel": "resultsStep-module__subdivisionLabel_dsellG__1100",
  "subdivisionName": "resultsStep-module__subdivisionName_dsellG__1100",
  "subdivisionSearchBox": "resultsStep-module__subdivisionSearchBox_dsellG__1100",
  "subdivisionSearchExpand": "resultsStep-module__subdivisionSearchExpand_dsellG__1100",
  "subdivisionSearchInput": "resultsStep-module__subdivisionSearchInput_dsellG__1100",
  "summary": "resultsStep-module__summary_dsellG__1100",
  "topicMenu": "resultsStep-module__topicMenu_dsellG__1100",
  "topicOption": "resultsStep-module__topicOption_dsellG__1100",
  "topicOptionSelected": "resultsStep-module__topicOptionSelected_dsellG__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      